import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasRole } from '../editor-eligibility-rule/editor-eligibility-rule-has-role.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-role',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueHasRoleComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasRole;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  roleNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.roleNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        roleNames => {
          this.roleNames = roleNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.roleNames === undefined) {
      return $localize `Not available`;
    }

    const roles = this.rule.getRolesAsString(this.roleNames);
    return this.affirmative
      ? $localize `Candidate has one of the roles: ${roles}`
      : $localize `Candidate has NONE of the roles: ${roles}`;
  }
}
